import { FC } from "react";

import dayjs from "dayjs";

import { ErrorHistory } from "../types";

type Props = {
  history: ErrorHistory[];
};

const History: FC<Props> = ({ history }: Props) => {
  return (
    <>
      {history.map((item) => (
        <div key={item.timestamp} className="mb-9 tracking-wider">
          <p className="text-xl text-white">{dayjs(item.timestamp).format("MMMM YYYY")}</p>
          <div className="border-b-2 border-gray-500 w-full my-5"></div>
          {item.errors.length ? (
            item.errors.map((error) => (
              <div key={`${error.timestamp}`} className="mt-6">
                <p className="text-base text-warning font-bold">{error.exception}</p>
                <p className="text-xs text-gray-500">{dayjs(error.timestamp * 1000).format("MMM DD, HH:mm")} EST</p>
              </div>
            ))
          ) : (
            <p className="text-sm text-white">No incidents reported for this month.</p>
          )}
        </div>
      ))}
    </>
  );
};

export default History;
